export default {
    state: {
      currentBoard: '',
      currentBoardPage: 1,
      currentEssayPage: 1,
      essayFocus: {
          list: false,
          view: false,
      },
      currentBoardKeywords: '',
      currentEssayKeywords: '',
      currentEssaySort: null,
    },
    mutations: {
      setCurrentBoard(state, board) {
          state.currentBoard = board;
      },
      setCurrentBoardPage(state, page) {
          state.currentBoardPage = page;
      },
      setCurrentEssayPage(state, page) {
          state.currentEssayPage = page;
      },
      setEssayFocus(state, {key, value}) {
          state.essayFocus[key] = value;
      },
      setCurrentBoardKeywords(state, keyword) {
        state.currentBoardKeywords = keyword;
      },
      setCurrentEssayKeywords(state, keyword) {
        state.currentEssayKeywords = keyword
      },
      setCurrentEssaySort(state, payload) {
        state.currentEssaySort = payload;
      },
    },
    actions: {
      saveCurrentBoard({commit}, board) {
          commit('setCurrentBoard', board);
      },
      saveCurrentBoardPage({commit}, page) {
          commit('setCurrentBoardPage', page);
      },
      saveCurrentEssayPage({commit}, page) {
          commit('setCurrentEssayPage', page);
      },
      saveEssayFocus({commit}, {key, value}) {
          commit('setEssayFocus', {key, value});
      },
      saveCurrentBoardKeywords({commit}, keywords) {
        commit('setCurrentBoardKeywords', keywords)
      },
      saveCurrentEssayKeywords({commit}, keywords) {
        commit('setCurrentEssayKeywords', keywords)
      },
      saveCurrentEssaySort({commit}, sort) { 
        commit('setCurrentEssaySort', sort) 
      },
    },
};